import { render, staticRenderFns } from "./MobileRoute.vue?vue&type=template&id=63e913c9&scoped=true&"
import script from "./MobileRoute.vue?vue&type=script&lang=js&"
export * from "./MobileRoute.vue?vue&type=script&lang=js&"
import style0 from "./MobileRoute.vue?vue&type=style&index=0&id=63e913c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e913c9",
  null
  
)

export default component.exports